export const release = "04-NOV-26 02:45:20";
export const lemmonEnv: any = (globalThis as any).lemmonEnv;
